<template>
  <div
    class="cursor-pointer"
    @click="$emit('update:modelValue', to)"
  >
    <slot :is-active="isActive" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  to: string,
  modelValue: string,
}>()

defineEmits(['update:modelValue'])
const isActive = computed(() => props.to === props.modelValue)
</script>
